import React from "react";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as c from "./lpCompetitorReviewBadges.module.scss";

const LpCompetitorReviewBadges = () => {
  const data = useStaticQuery(graphql`
    query ReviewBadgesQuery {
      badge1: file(relativePath: { eq: "review-badges/redesign/2025/1-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 92, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      badge2: file(relativePath: { eq: "review-badges/redesign/2025/2-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 74, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      badge3: file(relativePath: { eq: "review-badges/redesign/2025/3-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 110, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      badge4: file(relativePath: { eq: "review-badges/redesign/2025/4-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 75, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      badge5: file(relativePath: { eq: "review-badges/redesign/2025/5-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 82, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      badge6: file(relativePath: { eq: "review-badges/redesign/2025/6-badge-2025.png" }) {
        childImageSharp {
          gatsbyImageData(width: 74, layout: CONSTRAINED, placeholder: NONE)
        }
      }
    }
  `);

  const badges = [data.badge1, data.badge2, data.badge3, data.badge4, data.badge5, data.badge6];

  return (
    <div className={c.container}>
      <h3 className={classNames(c.heading, "h3")}>Don't just take our word for it</h3>
      <p className={classNames(c.subheading, "p3")}>Hear from real Mangomint customers why they made the switch</p>
      <div className={c.badgesContainer}>
        {badges.map((badge, index) => {
          const image = getImage(badge);
          return (
            <div key={index}>
              <GatsbyImage image={image} alt="" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LpCompetitorReviewBadges;
